import { useEffect, useMemo, useState } from 'react';
import { useEntities } from '@mb.io/core-components';

export const useCatalogEntitiesDetail = () => {
  const [page, setPage] = useState(0);

  const {
    formattedItems,
    loading,
    error,
    appliedFilters,
    updateFilters,
    queryParameters,
    pageInfo,
    totalItems,
    limit,
    offset,
    paginationMode,
    starredEntities,
    setLimit,
    setOffset,
  } = useEntities();

  useEffect(() => {
    const currentPage = offset ? offset / limit : 0;
    setPage(currentPage);
  }, [offset, limit]);

  return useMemo(() => {
    const handleChangePage = (newPage: number) => {
      setOffset?.(newPage * limit);
    };

    const handleChangeRowsPerPage = (itemsPerPage: number) => {
      setLimit(itemsPerPage);
      setPage(0);
    };

    return {
      formattedItems,
      page,
      totalItems,
      limit,
      loading,
      error,
      appliedFilters,
      updateFilters,
      queryParameters,
      pageInfo,
      offset,
      paginationMode,
      starredEntities,
      setLimit,
      handleChangePage,
      handleChangeRowsPerPage,
    };
  }, [
    formattedItems,
    page,
    totalItems,
    limit,
    loading,
    error,
    appliedFilters,
    updateFilters,
    queryParameters,
    pageInfo,
    offset,
    paginationMode,
    starredEntities,
    setLimit,
    setOffset,
  ]);
};
